export function getAuthenticatedUser(state) {
  return state.authentication.user || null;
}

export function isAuthenticated(state) {
  return state.authentication.user?.isLoggedIn;
}

export function hasSignedRequiredDocuments(state) {
  if (!isAuthenticated(state)) {
    return false;
  }

  const { unsignedDocuments } = state.authentication.user;

  const hasUnsignedDocuments = Array.isArray(unsignedDocuments) && unsignedDocuments.length > 0;

  return !hasUnsignedDocuments;
}

export function hasAnyPermission(state, anyOfPermissions = []) {
  if (!isAuthenticated(state)) {
    return false;
  }
  const { permissions } = state.authentication.user;
  return anyOfPermissions.some(p => permissions.includes(p));
}
